import BaseItem from '@/components/item/BaseItem/BaseItem.vue';
import HorizontalScroll from '@/components/base/HorizontalScroll/HorizontalScroll.vue';
export default {
  props: {
    data: {
      required: true
    }
  },
  computed: {
    normalList: function normalList() {
      return this.isMounted ? this.data.vActList : this.data.vActList.slice(0, 2);
    }
  },
  components: {
    HorizontalScroll: HorizontalScroll,
    BaseItem: BaseItem
  },
  ptag: 'kt',
  reportModule: '开通优惠',
  reportData: {
    '海报': function 海报(title, cubeId) {
      return {
        'f_module': '开通优惠',
        'f_resource': title + '海报',
        'f_type': 5,
        'f_cubeid': cubeId
      };
    }
  }
};